import React from 'react'

const SESSION_COLOR = '#9b6cc4'

const LABELS = { 1: 'Not useful', 2: 'Slightly', 3: 'Okay', 4: 'Useful', 5: 'Very useful' }

function RatingRow({ label, value, onChange, readOnly, otherHasRated }) {
  const canSee = value != null
  const showEmpty = !canSee && !otherHasRated

  return (
    <div style={styles.row}>
      <span style={styles.rowLabel}>{label}</span>
      <div style={styles.dots}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            style={{
              ...styles.dot,
              ...(value === n ? styles.dotSelected : {}),
              ...((readOnly || !onChange) ? styles.dotReadOnly : {}),
            }}
            onClick={() => onChange && !readOnly && onChange(n)}
            disabled={readOnly || !onChange}
            aria-label={`Rate ${n}`}
            aria-pressed={value === n}
          >
            {value === n && <span style={styles.dotInner} />}
          </button>
        ))}
      </div>
      <span style={styles.ratingLabel}>
        {canSee ? LABELS[value] : (showEmpty ? '—' : '—')}
      </span>
    </div>
  )
}

export function DualRating({ reportRating, managerRating, isReport, onChange, readOnly = false }) {
  const bothRated = reportRating != null && managerRating != null

  // Each person can see their own rating immediately; the other's only after both have rated.
  const reportVisible = isReport ? reportRating : (bothRated ? reportRating : null)
  const managerVisible = !isReport ? managerRating : (bothRated ? managerRating : null)

  function handleReportChange(val) {
    if (isReport && !readOnly) onChange?.({ reportRating: val, managerRating })
  }
  function handleManagerChange(val) {
    if (!isReport && !readOnly) onChange?.({ reportRating, managerRating: val })
  }

  const myRow = (
    <RatingRow
      key="mine"
      label="You"
      value={isReport ? reportRating : managerRating}
      onChange={isReport ? handleReportChange : handleManagerChange}
      readOnly={readOnly}
      otherHasRated={isReport ? managerRating != null : reportRating != null}
    />
  )
  const theirRow = (
    <RatingRow
      key="theirs"
      label={isReport ? 'Manager' : 'Report'}
      value={isReport ? managerVisible : reportVisible}
      onChange={null}
      readOnly
      otherHasRated={isReport ? reportRating != null : managerRating != null}
    />
  )

  return (
    <div style={styles.wrap}>
      {myRow}
      {theirRow}
    </div>
  )
}

const styles = {
  wrap: { padding: '12px 12px 14px', display: 'flex', flexDirection: 'column', gap: '10px' },
  row: { display: 'flex', alignItems: 'center', gap: '8px' },
  rowLabel: { fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', minWidth: '52px' },
  dots: { display: 'flex', gap: '5px' },
  dot: {
    width: '18px', height: '18px', borderRadius: '50%', flexShrink: 0,
    border: `1.5px solid ${SESSION_COLOR}44`, background: 'transparent',
    cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'border-color var(--duration-fast) ease',
  },
  dotSelected: { borderColor: SESSION_COLOR },
  dotReadOnly: { cursor: 'default' },
  dotInner: {
    width: '8px', height: '8px', borderRadius: '50%', background: SESSION_COLOR,
  },
  ratingLabel: { fontSize: '10px', color: 'var(--text-secondary)', opacity: 0.7, minWidth: '60px' },
}
